import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { deleteAllCards, getMessengerService, getPlans, setAddCardFormData, setAdvancementPayMethod, setCreditCardInfo, setCvvForAnonimous, setLoadingTokenizationCard, setPaymentMethod, setTokenizationCard } from "../../store/actions";
import styled from "styled-components";
import { executeTaggeo } from "../../store/actions";
import { getBundleIdFromUrl, getBundleVersionFromUrl, getCanEncript, getCanMultiAnalytics, getCanRegisterEmailSelector, getCanTokenCompleteSelector, getUserInfoLiteSelector } from "../../store/selectors/paymentsSelectors";
import { useClaropaySdk } from "../../services/sdk/SDKServiceWeb.tsx";
import * as sdkclaro from '@claropay/claro-pay-sdk-v2';
import { ClaroSDKService } from "../../services/sdk/ClaroSDKService.js";

const ContainerTokenization = styled.div`
  white-space: nowrap;
  word-spacing: 0;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  background: transparent;
  border: none;
  line-height: normal;
  box-sizing: border-box;
  background-clip: padding-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
  font-weight: 400;
  font-weight: var(--font-weight);
  overflow: hidden;
  background-color: transparent;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: table;
  z-index: 2147483647;
  #tokenization {
    height: 100%;
  }
`;
class TokenizationCardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idContainer: "tokenization",
    };
  }

  async componentDidMount() {
     this.processCard();
  }

  processCard = async () => {
    console.debug("init processCard");
    try {
      sdkclaro.getInstance().switchGoBackButton(true);
      this.props.getMessengerService("TokenizationCard");
      // console.log(window.history)
      // console.log(this.props.history)
      // console.log(this.props.history.location);
      // console.log(this.props.userInfoLite);
      if(window.history.length === 1){
        window.history.pushState({}, "", "");
      }
      // Get tokens from web sdk
      const tokenFull = await ClaroSDKService.getFullToken();
      // Set token
      await useClaropaySdk().setToken(false, tokenFull);
    } catch (error) {
    }
    setTimeout(() => {
      this.props.setLoadingTokenizationCard(false);
    }, 1000);
    let saveCard = await useClaropaySdk().openTokenizationCard(
      this.state.idContainer,
      {
        "bundleId":this.props.bundleId,
        "env":{
            telcelBundleVersions: process.env.REACT_APP_TELCEL_BUNDLE_VERSIONS,
            claroPayBundleVersions: process.env.REACT_APP_CLARO_PAY_BUNDLE_VERSIONS,
            "passwordEncrypt":window.atob(
              process.env.REACT_APP_SDK_PASSWORD_ENCRYPT
                ? process.env.REACT_APP_SDK_PASSWORD_ENCRYPT
                : '4a$NGEkc1dvcjBs',
            ),
            proxiServer: process.env.REACT_APP_SERVICE_PROXY_SERVER,
            proxiServerApiKey: process.env.REACT_APP_SERVICE_PROXY_SERVER_API_KEY,
            configuration: process.env.REACT_APP_SERVICE_CONFIGURATION,
            configurationApiKey: process.env.REACT_APP_SERVICE_CONFIGURATION_API_KEY,
            appsyncCountry: process.env.REACT_APP_APPSYNC_COUNTRY_ID,
            "appsyncbundleId":this.props.bundleId,
            "appsyncbundleVersion":this.props.bundleVersion,
            appsyncBank: process.env.REACT_APP_APPSYNC_BANK_ID,
            "deleteAllCards": process.env.REACT_APP_DELETE_ALL_CARDS_URL,
            "deleteAllCardsApiKey": process.env.REACT_APP_DELETE_ALL_CARDS_API_KEY,
        },
        "flags":{
            "canEncryptValue":this.props.canEncript,
            "buttonsBelow": true,
            "showCvv":!this.props.hideCvv,
            "canMultiAnalytics":this.props.canMultiAnalytics,
            "isTemporalClaroId": this.props.isAnonimous,
            "canGetToken": this.props.canGetToken,
            "canRegisterEmail": this.props.canRegisterEmail,
        },
        "showHeader":false,
        "updateCard": this.props.updateCard,
        profile: this.props.userInfoLite,
        origin: this.props.paymentsConfig && this.props.paymentsConfig.tagServiceId? this.props.paymentsConfig.tagServiceId : this.props.serviceName,
      },
      (data) => { 
         console.debug("onEvent");
        console.debug(data);
        if ("_close_mf_" === data.event) {
         this.props.setTokenizationCard( {
              result: "declined",
            });
      }
      },
      sdkclaro.getInstance(),
    );
    saveCard = JSON.parse(saveCard);
    console.debug("saveCard response");
    console.debug(saveCard);
    if(saveCard.success === true){
      console.debug("respuesta saveCard::");
      console.debug(JSON.stringify(saveCard));
      this.props.setCvvForAnonimous(saveCard.data.cardCvv);
      setTimeout(()=> {
        // Launch search card
        this.props.setPaymentMethod({
          cardId: saveCard.data.cardId,
          cardCvv: saveCard.data.cardCvv,
        });
        // if (!this.props.isAnonimous && !this.props.isContainerTelcel) {
        //   // Show snackbar    
        //     const url = {
        //         app: "startEventNoClose",
        //         to : "showContainerSnackBar",
        //         parameters: JSON.stringify({show: "true",name:"highlightMB",cp:"CP0005",flow:"TokenizationCard",type:"positive"}),
        //     };
        //     const snackbarSaveCardSuccessParams = JSON.stringify(url)
        //     sdkclaro.getInstance().openNative(snackbarSaveCardSuccessParams);
        //     this.props.executeTaggeo({
        //         step: "Formulario de pago",
        //         action: "View snackbar Tarjeta guardada",
        //         eventName:"pay_service_or_tae",
        //         service: this.props && this.props.paymentsConfig && this.props.paymentsConfig.tagServiceId
        //     });
        // }
        this.props.closeTokenizationCard({
          cardId: saveCard.data.cardId,
          cardCvv: saveCard.data.cardCvv,
          value : saveCard.data.cardId,
        });
      }, 500);
      // Clear customerIndex
      ClaroSDKService.clearCustomerIndex();
    }
  }

  render() {

    return (
      <ContainerTokenization>
        <div id={this.state.idContainer}></div>
      </ContainerTokenization>
    );
  }
}

function mapStateToProps(state) {
  const userInfoLite = getUserInfoLiteSelector(state);

  return {
    paymentMethods: state.payments.paymentMethods,
    plans: state.payments.plans,
    isLoadingGetPlans: state.payments.isLoadingGetPlans,
    errorPlans: state.payments.errorPlans,
    isAnonimous: state.payments.isAnonimous,
    userInfoLite: userInfoLite,
    paymentAmountFromUrl: state.payments.getPaymentAmountFromUrl,
    productId: state.payments.getProductIdFromUrl,
    goToMicroappAdelanto: state.payments.goToMicroappAdelanto,
    paramsFromurl: state.payments.params,
    canEncript: getCanEncript(state),
    canMultiAnalytics: getCanMultiAnalytics(state),
    bundleId: getBundleIdFromUrl(state),
    bundleVersion: getBundleVersionFromUrl(state),
    canGetToken: getCanTokenCompleteSelector(state),
    canRegisterEmail: getCanRegisterEmailSelector(state),
    isContainerTelcel: state.payments.isContainerTelcel
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getPlans,
      executeTaggeo,
      setAdvancementPayMethod,
      setTokenizationCard,
      setPaymentMethod,
      deleteAllCards,
      setAddCardFormData,
      setCvvForAnonimous,
			setCreditCardInfo,
      getMessengerService,
      setLoadingTokenizationCard,
    },
    dispatch
  );
}

TokenizationCardContainer = connect(mapStateToProps, mapDispatchToProps)(TokenizationCardContainer);

export default TokenizationCardContainer;
